import React, { createContext, useContext, useEffect, useState } from 'react';
import { useWebSocket } from './WebSocketContext';
import { useUser } from './UserContext';
import { queueOverview } from '../utils/fightQueue';

const Context = createContext(null);
export function QueueOverviewProvider({ children }) {
  const { fightStatus, fightInfo } = useWebSocket();
  const { user } = useUser();
  const userId = user?.id || user?.userId;
  const [overview, setOverview] = useState(null);
  useEffect(() => {
    setOverview(null);
    if (!userId || (fightStatus !== 20 && fightStatus !== 30)) return;
    let stopped = false, timer;
    const refresh = async () => {
      try {
        const reply = await queueOverview();
        if (!stopped) setOverview(reply.data);
      } catch { /* Retain the last confirmed count until the next successful read. */ }
      if (!stopped) timer = setTimeout(refresh, 4000 + Math.random() * 2000);
    };
    refresh();
    return () => { stopped = true; clearTimeout(timer); };
  }, [fightStatus, fightInfo?.id, userId]);
  return <Context.Provider value={overview}>{children}</Context.Provider>;
}
export const useQueueOverview = () => useContext(Context);
